import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-cfc8a2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark fixed-top bg-dark" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "40",
    alt: "logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "home"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "GARAGE DE VUYST")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_8 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item ms-3" }
const _hoisted_11 = { class: "nav-item ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "navbar-toggler",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ToggleMobileMenu'))),
        type: "button"
      }, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "javascript:void()",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Scroll(1)))
            }, "Over ons")
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "javascript:void()",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Scroll(4)))
            }, "Ons vinden")
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.Toggle()))
            }, " Contact ")
          ])
        ])
      ])
    ])
  ]))
}